import { useState } from 'react';
import { NotificationManager } from 'react-notifications';
import { useSelector } from 'react-redux';

import { dayjs } from '../../../utils/dayjs-utils';
import ButtonComponent from '../ButtonComponent/ButtonComponent';
import IconContainer from '../FtuxComponent/IconContainer';
import ModalComponent from './ModalComponent';

import './_resubscriptionModal.scss';

import { getShortFormForPlanInterval } from '@/utils/subscription-utils';

import {
  removePauseFromSubscription,
  reSubscribeUser,
  revertCancellationInStripe,
} from '../../../services/payment.service';

export default function ResubscriptionModal({ show, handleClose, handleLogout, handleSubscriptionCancellation }) {
  const [loading, setLoading] = useState(false);
  const { userDetails } = useSelector((state) => state.user);

  const newPlanPrice =
    Number(userDetails?.plan?.price) > 499 || userDetails?.isDiscountApplied ? Number(userDetails?.plan?.price) : 499;
  const revertCancellation = async () => {
    setLoading(true);
    const response = await revertCancellationInStripe();
    if (response?.status) {
      NotificationManager.success('Subscription resumed successfully!', '', 1800);
      setTimeout(() => {
        window.location.reload();
        setLoading(false);
      }, 2500);
    } else {
      NotificationManager.error('Something went wrong!', '', 1500);
      setLoading(false);
    }
  };

  const handleRemovePauseFromSubscription = async () => {
    const response = await removePauseFromSubscription();
    if (response?.status) {
      NotificationManager.success('Subscription resumed successfully! Please wait for screen to refresh', '', 1800);
      setTimeout(() => {
        window.location.reload();
        setLoading(false);
      }, 5000);
    } else {
      NotificationManager.error('Something went wrong!', '', 1500);
      setLoading(false);
    }
  };

  return (
    <ModalComponent show={show} onClose={handleClose} width={467} outsideClickClose={false}>
      <div className="warning-modal modal-main-content" style={{ padding: '8px' }}>
        <IconContainer icon="🤝" />
        <h2 style={{ width: '100%', fontSize: 18, margin: '24px 0 16px 0' }}>
          {userDetails?.subscriptionStatus === 'cancelled' && 'It seems you cancelled your subscription…'}
          {userDetails?.subscriptionStatus === 'pause' && 'It seems you paused your subscription…'}
        </h2>
        {userDetails?.subscriptionStatus === 'cancelled' && (
          <>
            <p className="enter-list-name">
              We detected that you cancelled your subscription
              <br />
              {userDetails?.cancelledAt ? ` on ${dayjs(userDetails?.cancelledAt).format('Do MMMM YYYY')}` : ''}. Welcome
              back to SARAL!
            </p>
            <br />
            <p className="enter-list-name">Do you want to re-activate your trial again?</p>
            <br />
          </>
        )}

        {userDetails?.subscriptionStatus === 'pause' && (
          <>
            <p className="enter-list-name">
              We detected that you paused your subscription <br />
              {userDetails?.pausedAt ? ` on ${dayjs(userDetails?.pausedAt).format('Do MMMM YYYY')}` : ''}. Welcome back
              to SARAL!
            </p>
            <br />
            <p className="enter-list-name">
              Do you want to re-activate your plan? SARAL costs ${newPlanPrice}/
              {getShortFormForPlanInterval(userDetails?.plan?.type) || 'mo'}.
            </p>
            <br />
          </>
        )}

        <p className="enter-list-name">
          If you have any questions, please reach out to us in the support chat on the bottom right.
        </p>

        <div className="extension-modal-footer-button-container">
          <ButtonComponent
            onClick={() => {
              if (userDetails?.subscriptionStatus === 'cancelled' && userDetails?.isSubscribed) {
                revertCancellation();
              } else if (userDetails?.subscriptionStatus === 'pause') {
                handleRemovePauseFromSubscription();
              }
            }}
            showLoading={loading}>
            {userDetails?.subscriptionStatus === 'cancelled' ? 'Yes, Re-Activate My Trial' : 'Yes, Re-Activate My Plan'}
          </ButtonComponent>
          <ButtonComponent onClick={handleLogout} variant="secondary" style={{ marginTop: 16 }}>
            Logout
          </ButtonComponent>
          {userDetails?.subscriptionStatus === 'pause' && (
            <div onClick={() => handleSubscriptionCancellation()} className="warning-footer">
              Cancel Subscription &gt;&gt;
            </div>
          )}
        </div>
      </div>
    </ModalComponent>
  );
}
